import { useState } from "react"
import { Button, Form } from "react-bootstrap"
import placeService from "../../services/places.service"
import uploadService from '../../services/upload.service'


const NewPlaceForm = ({ closeModal, refreshPlaces }) => {


    const [placeData, setPlaceData] = useState({
        name: "",
        description: "",
        placeImg: "",
        lat: 0,
        lng: 0
    })

    const [loadingImage, setLoadingImage] = useState(false)

    const { name, description, placeImg, lat, lng } = placeData

    const location = {
        type: "Point",
        coordinates: [lat, lng]
    }

    const handleInputChange = e => {

        const { value, name } = e.target

        setPlaceData({
            ...placeData,
            [name]: value
        })
    }

    const uploadPlaceImage = e => {

        setLoadingImage(true)

        const uploadData = new FormData()

        uploadData.append('imageData', e.target.files[0])

        uploadService
            .uploadImage(uploadData)
            .then(({ data }) => {
                setLoadingImage(false)
                setPlaceData({name, description, location, placeImg: data.cloudinary_url})
            })
            .catch(err => console.log(err))
    }

    const handleSubmit = e => {

        e.preventDefault()

        placeService
            .savePlace(placeData)
            .then(({ data }) => {
                refreshPlaces()
                closeModal()
            })
            .catch(err => console.log(err))
    }

    return(
        <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="name">
            <Form.Label>Nombre de la escuela</Form.Label>
            <Form.Control type="text" value={name} onChange={handleInputChange} name="name" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="description">
            <Form.Label>Descripción de la escuela</Form.Label>
            <Form.Control type="text" value={description} onChange={handleInputChange} name="description" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="lat">
            <Form.Label>Lat</Form.Label>
            <Form.Control type="number" value={lat} onChange={handleInputChange} name="lat" />
        </Form.Group>

        <Form.Group className="mb-3" controlId="lng">
            <Form.Label>Lng</Form.Label>
            <Form.Control type="number" value={lng} onChange={handleInputChange} name="lng" />
        </Form.Group>

        <Form.Group controlId="placeImg" className="mb-3">
            <Form.Label>Imagen de la escuela</Form.Label>
            <Form.Control type="file" onChange={uploadPlaceImage} />
        </Form.Group>

        <div className="d-grid gap-2">
            <Button style={{backgroundColor: "#b13636"}} type="submit" disabled={loadingImage}>{loadingImage ? 'Espere...' : 'Crear escuela'}</Button>
        </div>

    </Form >
    )
}

export default NewPlaceForm